<template>
<div class="chapter">
<div class="inner_page">
<p class="normal2-a">Der Mensch gebärdet sich, als sei er Bildner und Meister der Sprache, während doch sie die Herrin des Menschen bleibt. Wenn dieses Herrschaftsverhältnis sich umkehrt, dann verfällt der Mensch auf selt-same Machenschaften. Die Sprache wird zum Mittel des Ausdrucks. Als Ausdruck kann die Sprache zum blossen Druckmittel herabsinken. Dass man auch bei solcher Benutzung der Sprache noch auf die Sorgfalt des Sprechens hält, ist gut. Dies allein hilft uns jedoch nie aus der Verkehrung des wahren Herrschaftsverhältnisses zwischen der Sprache und dem Menschen. Denn eigentlich spricht die Sprache. Der Mensch spricht erst und nur, insofern er der Sprache entspricht, indem er auf ihren Zuspruch hört. Unter allen Zusprüchen, die wir Menschen von uns her nie zum Sprechen bringen dürfen, ist die Sprache der höchste und der überall erste.</p>
<p class="right2-a"><span><span class="smallcaps">MARTIN HEIDEGGER</span>, ‘… Dichterisch Wohnet der</span></p>
<p class="right2-b"><span>Mensch …’ 1954</span></p>
<p class="normal1-a">Ningún problema tan consustancial con las letras y con su modesto misterio como el que propone una traducción.</p>
<p class="right2-b"><span><span class="smallcaps">J</span>.-<span class="smallcaps">L</span>. <span class="smallcaps">BORGES</span>, ‘Las versiones Homéricas,’ <i>Discusión</i>, 1957</span></p>
<p class="normal1-a">La théorie de la traduction n’est donc pas une linguistique appliquée. Elle est un champ nouveau dans la théorie et la pratique de la littérature. Son importance épistémologique consiste dans sa contribution à une pratique théorique de l’homogénéité entre signifiant et signifié propre à cette pratique sociale qu’est l’écriture.</p>
<p class="right2-a"><span><span class="smallcaps">HENRI MESCHONNIC</span>, <i>Pour la poétique II</i>, 1973</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter3.vue?0cc526a4